export const supplierProductGetters = {
  supplierProductFormStatus: (state) => state.supplierProductFormStatus,
  supplierProductIsEdit: (state) => state.supplierProductIsEdit,
  supplierProductSelectedForEdit: (state) =>
    state.supplierProductSelectedForEdit,
  ProductSearchFilterParams: (state) => state.ProductSearchFilterParams,
  IndustrialServiceSearchFilterParams: (state) =>
    state.IndustrialServiceSearchFilterParams,
  ElectronicDocumentSearchFilterParams: (state) =>
    state.ElectronicDocumentSearchFilterParams,
  ConsultingServiceSearchFilterParams: (state) =>
    state.ConsultingServiceSearchFilterParams,
  ProductPageNumber: (state) => state.ProductPageNumber,
  ProductItemsPerPage: (state) => state.ProductItemsPerPage,
  ProductSelectedItem: (state) => state.ProductSelectedItem,
  ProductCurrentList: (state) => state.ProductCurrentList,
  IndustrialServicePageNumber: (state) => state.IndustrialServicePageNumber,
  IndustrialServiceItemsPerPage: (state) => state.IndustrialServiceItemsPerPage,
  IndustrialServiceSelectedItem: (state) => state.IndustrialServiceSelectedItem,
  IndustrialServiceCurrentList: (state) => state.IndustrialServiceCurrentList,
  ElectronicDocumentPageNumber: (state) => state.ElectronicDocumentPageNumber,
  ElectronicDocumentItemsPerPage: (state) =>
    state.ElectronicDocumentItemsPerPage,
  ElectronicDocumentSelectedItem: (state) =>
    state.ElectronicDocumentSelectedItem,
  ElectronicDocumentCurrentList: (state) => state.ElectronicDocumentCurrentList,
  ConsultingServicePageNumber: (state) => state.ConsultingServicePageNumber,
  ConsultingServiceItemsPerPage: (state) => state.ConsultingServiceItemsPerPage,
  ConsultingServiceSelectedItem: (state) => state.ConsultingServiceSelectedItem,
  ConsultingServiceCurrentList: (state) => state.ConsultingServiceCurrentList,
};
